export default "__VITE_ASSET__Dv5L3ORt__"